"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FeedbackPopup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var trello_1 = require("@powerupsclub/trello");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var textarea_1 = __importDefault(require("@atlaskit/textarea"));
var checkbox_1 = __importDefault(require("@atlaskit/checkbox"));
var button_1 = require("@atlaskit/button");
var payments_1 = require("@powerupsclub/payments");
var Label = styled_components_1["default"].label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: var(--ds-text-subtle, #5e6c84);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  margin-top: 0;\n  margin-bottom: 4px;\n"], ["\n  color: var(--ds-text-subtle, #5e6c84);\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16px;\n  margin-top: 0;\n  margin-bottom: 4px;\n"])));
var FeedbackFormContainer = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 14px;\n\n  form {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n"], ["\n  font-size: 14px;\n\n  form {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n"])));
var RadioContainer = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 4px;\n  display: flex;\n  gap: 8px;\n  margin-bottom: 4px;\n"], ["\n  margin-top: 4px;\n  display: flex;\n  gap: 8px;\n  margin-bottom: 4px;\n"])));
var SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';
var FeedbackPopup = function () {
    var _a = (0, react_1.useContext)(trello_1.TrelloPowerUpContext), trelloIframe = _a.trelloIframe, appName = _a.appName, powerUpKey = _a.powerUpKey, token = _a.token;
    var _b = (0, react_1.useContext)(payments_1.PaymentsContext), subscription = _b.subscription, trialEndDate = _b.trialEndDate;
    var _c = (0, react_1.useState)(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = (0, react_1.useState)(false), isSubmitting = _d[0], setIsSubmitting = _d[1];
    (0, react_1.useEffect)(function () {
        var _a;
        if ((_a = window.localizer) === null || _a === void 0 ? void 0 : _a.resourceDictionary) {
            setIsLoading(false);
        }
        trelloIframe.render(function () {
            setIsLoading(false);
        });
    }, []);
    var onSubmit = (0, react_1.useCallback)(function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var data, useful, comment, allowContact, boardMembers, onTrial, hasSubscription, jwt;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    setIsSubmitting(true);
                    data = new FormData(e.target);
                    useful = data.get('useful') === 'yes';
                    comment = data.get('comment');
                    allowContact = data.get('allowContact') === 'true';
                    return [4 /*yield*/, trelloIframe.board('members')];
                case 1:
                    boardMembers = (_a.sent()).members;
                    onTrial = trialEndDate && new Date() < trialEndDate;
                    hasSubscription = (subscription === null || subscription === void 0 ? void 0 : subscription.status) === 'active';
                    return [4 /*yield*/, trelloIframe.jwt({
                            state: JSON.stringify({
                                useful: useful,
                                comment: comment,
                                allowContact: allowContact,
                                token: token,
                                powerUpKey: powerUpKey,
                                numberOfBoardMembers: boardMembers.length,
                                onTrial: onTrial,
                                hasSubscription: hasSubscription
                            })
                        })];
                case 2:
                    jwt = _a.sent();
                    return [4 /*yield*/, fetch("".concat(SERVER_URL, "/feedback"), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                jwt: jwt
                            })
                        })];
                case 3:
                    _a.sent();
                    trelloIframe.confetti();
                    trelloIframe.closePopup();
                    trelloIframe.alert({
                        message: trelloIframe.localizeKey('Your feedback has been submitted')
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [trelloIframe, token, subscription, trialEndDate, powerUpKey]);
    if (isLoading) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(FeedbackFormContainer, { children: (0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: onSubmit }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Label, { children: trelloIframe.localizeKey('did-you-find-appName-useful', {
                                appName: appName
                            }) }, void 0), (0, jsx_runtime_1.jsxs)(RadioContainer, { children: [(0, jsx_runtime_1.jsx)("input", { type: "radio", name: "useful", value: "yes", id: "useful-yes", defaultChecked: true }, void 0), (0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "useful-yes" }, { children: trelloIframe.localizeKey('yes') }), void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(RadioContainer, { children: [(0, jsx_runtime_1.jsx)("input", { type: "radio", name: "useful", value: "no", id: "useful-no" }, void 0), (0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "useful-no" }, { children: trelloIframe.localizeKey('no') }), void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Label, { children: trelloIframe.localizeKey('Tell us how you really feel', {
                                appName: appName
                            }) }, void 0), (0, jsx_runtime_1.jsx)(textarea_1["default"], { name: "comment", minimumRows: 7, placeholder: trelloIframe.localizeKey('Bug reports, feature requests, Power-Up ideas, or any questions are welcome!') }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(checkbox_1["default"], { name: "allowContact", label: trelloIframe.localizeKey('Tiny Power-Ups Club can contact me regarding this feedback'), value: "true" }, void 0), (0, jsx_runtime_1.jsx)(button_1.LoadingButton, __assign({ type: "submit", appearance: "primary", shouldFitContainer: true, isLoading: isSubmitting }, { children: trelloIframe.localizeKey('Submit') }), void 0)] }), void 0) }, void 0));
};
exports.FeedbackPopup = FeedbackPopup;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=FeedbackPopup.js.map